import { useEffect, useState } from 'react';

import { PaymentInfo } from '../../../interfaces/paymentResult';
import { PaymentResultQueryParamsKeys } from '../../../constants/pathQueryParams';
import {
  SCAN_IQ_PAYMENT_RESULT_TYPE,
  ScanIqPaymentResultType,
} from '../../../constants/scanIqPaymentResultType';
import { getPaymentResultParams } from '../../../utils/getPaymentResultParams';
import { paymentResultService } from '../../../services/paymentResultService';

type UseScanIqPaymentResultReturn = {
  paymentInfo: PaymentInfo | null;
  params: Record<PaymentResultQueryParamsKeys, any>;
  paymentResultType: ScanIqPaymentResultType;
  isSuccess: boolean;
};

export const useScanIqPaymentResult = (): UseScanIqPaymentResultReturn => {
  const [paymentInfo, setPaymentInfo] = useState<PaymentInfo | null>(null);

  const params = getPaymentResultParams();
  const {
    paymentIntentId,
    connectedAccountId,
    paymentTimeEpoch,
    senderName,
    paymentResultType,
    redirectStatus,
  } = params;

  const isSuccess = redirectStatus === 'succeeded';

  const getPaymentInfo = async () => {
    if (!paymentIntentId || !connectedAccountId) {
      console.error('Not all required data is set');
    } else {
      //TODO: use request specific for ScanIQ when backend will provide it
      const result = await paymentResultService.getPaymentDetails(
        paymentIntentId,
        connectedAccountId,
      );

      setPaymentInfo(result);
    }
  };

  const getPaymentInfoForFreeSubscription = async () => {
    if (!paymentTimeEpoch || !senderName) {
      console.error('Not all required data is set');
    } else {
      setPaymentInfo({
        paymentTimeEpoch,
        senderName,
        amount: 0,
        paymentMethod: null,
        cardFunding: null,
        currency: '',
        amountExcludingTax: 0,
      });
    }
  };

  const processPaymentDetails = () => {
    switch (paymentResultType) {
      case SCAN_IQ_PAYMENT_RESULT_TYPE.FREE:
        getPaymentInfoForFreeSubscription();
        break;
      case SCAN_IQ_PAYMENT_RESULT_TYPE.WITH_PAYMENT:
        getPaymentInfo();
        break;
      case SCAN_IQ_PAYMENT_RESULT_TYPE.ALREADY_SUBSCRIBED:
      default:
        break;
    }
  };

  useEffect(() => {
    processPaymentDetails();
  }, [paymentResultType]);

  return {
    paymentInfo,
    params,
    paymentResultType,
    isSuccess,
  };
};
